const publicPath = "/";

export const routes = {
  START_PAGE: publicPath,
  ABOUT_PAGE: `${publicPath}about`,
  CONTACT_PAGE: `${publicPath}contact`,
  PROJECTS_PAGE: `${publicPath}videography`,
  PHOTOGRAPHY_PAGE: `${publicPath}photography`,
};
